export const queryKeys = {
    STRIKES: "strikes",
    GET_TASK: 'get-tasks',
    DELETE: "strikes-delete",
    EVENT_GET: "event-get",
    EVENT_DELETE: "event-delete"
}